<template>
  <v-dialog
    v-model="showFormDialog"
    max-width="50vw"
    @click:outside="closeForm"
  >
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-form ref="form" v-model="valid" @submit.prevent="saveItem">
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="form.name"
                  prepend-icon="mdi-account-key"
                  label="Name"
                  :rules="rules.name"
                ></v-text-field>
                <v-text-field
                  v-model="form.guard_name"
                  prepend-icon="mdi-shield-half-full"
                  label="Guard Name"
                  :rules="rules.guard_name"
                ></v-text-field>
                <v-select
                  v-model="form.permissions"
                  :items="forSelect(filterPermissions)"
                  prepend-icon="mdi-lock"
                  item-text="text"
                  item-value="id"
                  chips
                  multiple
                  label="Permissions"
                  @onChange="test(form)"
                >
                  <template v-slot:selection="{ item }">
                    <v-chip>{{ item.text }}</v-chip>
                  </template>
                </v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="gray"
            :disabled="sending || savedItem != null"
            @click="closeForm"
            >{{ $t("button.Cancel") }}</v-btn
          >
          <v-btn
            type="submit"
            :disabled="sending || savedItem != null"
            color="primary"
            >{{ $t("button.Save") }}</v-btn
          >
        </v-card-actions>
      </v-form>
      <v-progress-linear
        v-if="sending"
        color="deep-purple accent-4"
        indeterminate
        rounded
        height="6"
      ></v-progress-linear>
      <v-alert v-if="errorMessage" tile class="mb-0" type="error">{{
        errorMessage
      }}</v-alert>
      <v-alert v-if="savedItem" tile type="success" class="mb-0"
        >{{ $t("user.The user") }}{{ savedItem.name }}
        {{ $t("user.was saved") }}</v-alert
      >
    </v-card>
  </v-dialog>
</template>

<script>
import crudMixin from "mixins/crudForm";

export default {
  mixins: [crudMixin],
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      apiQuery: "/roles/",
      rules: {
        name: [(v) => !!v || "Required."],
        guard_name: [
          (v) => (this.editedItem === null ? !!v || "Required." : true),
          // () => this.serverErrors,
        ],
      },
    };
  },
  computed: {
    formTitle() {
      return this.editedItem === null
        ? this.$t("roles and permissions.add role")
        : this.$t("roles and permissions.edit role");
    },
    filterPermissions() {
      let data = [];
      for (let id in this.data) {
        if (this.data[id].guard_name === this.form.guard_name) {
          data[id] = this.data[id].name;
        }
      }
      return data;
    },
  },
  methods: {},
};
</script>
